import script from "./SkyscraperIframe.vue?vue&type=script&setup=true&lang=js"
export * from "./SkyscraperIframe.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__